import React, { useState, useEffect, useRef, useCallback } from 'react';
import './AdminRecursosGratis.css';

const API_LEADS  = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php';
const API_UPLOAD = 'https://centrocomunicar.com/api-comunicar/endpoints/upload.php';
const BASE_URL   = 'https://centrocomunicar.com/gratis';

/* ── Icons ── */
const IconUpload   = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconFile     = () => (<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconInstagram= () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconQR       = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="3" y="3" width="7" height="7" stroke="currentColor" strokeWidth="2"/><rect x="14" y="3" width="7" height="7" stroke="currentColor" strokeWidth="2"/><rect x="3" y="14" width="7" height="7" stroke="currentColor" strokeWidth="2"/><rect x="14" y="14" width="3" height="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconEyeOff   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);


const TIPOS       = ['pdf','clase','muestra','plantilla'];
const CATEGORIAS  = ['Lenguaje','TEA','Habla','Aprendizaje','Tartamudez','General'];
const TIPO_COLOR  = { pdf:'verde', clase:'azul', muestra:'amarillo', plantilla:'morado' };
const EXT_ICON    = { pdf:'📄', doc:'📝', docx:'📝', ppt:'📊', pptx:'📊', xlsx:'📈', xls:'📈', zip:'🗜️', mp4:'🎥', png:'🖼️', jpg:'🖼️', jpeg:'🖼️' };

const FORM_EMPTY = { titulo:'', descripcion:'', tipo:'pdf', categoria:'Lenguaje', slug:'', utm_campaign:'' };

function slugify(t) {
  return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9\s-]/g,'').replace(/[\s]+/g,'-').trim();
}

export default function AdminRecursosGratis() {
  const [recursos,    setRecursos]   = useState([]);
  const [loading,     setLoading]    = useState(false);
  const [toast,       setToast]      = useState(null);
  const [copiedLink,  setCopiedLink] = useState(null);

  // Modales
  const [modalUpload,   setModalUpload]   = useState(null);   // slug
  const [modalEdit,     setModalEdit]     = useState(null);   // recurso obj
  const [modalNuevo,    setModalNuevo]    = useState(false);
  const [modalDescargas,setModalDescargas]= useState(null);   // { recurso, descargas[] }

  // Form editar/nuevo
  const [form,       setForm]      = useState(FORM_EMPTY);
  const [guardando,  setGuardando] = useState(false);

  // Upload
  const [uploading,  setUploading] = useState(false);
  const [progreso,   setProgreso]  = useState(0);
  const [dragOver,   setDragOver]  = useState(false);
  const fileRef = useRef();

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3500); };
  const setF = (k,v) => setForm(f=>({...f,[k]:v}));

  /* ── Fetch recursos ── */
  const fetchRecursos = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_LEADS}?action=recursos_admin`);
      const j = await r.json();
      if (j.success) setRecursos(j.data || []);
    } catch(e) { showToast('Error cargando recursos','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchRecursos(); }, [fetchRecursos]);

  /* ── Fetch descargas de un recurso ── */
  const verDescargas = async (recurso) => {
    try {
      const r = await fetch(`${API_LEADS}?action=descargas_recurso&recurso_id=${recurso.id}`);
      const j = await r.json();
      setModalDescargas({ recurso, descargas: j.data || [] });
    } catch(e) {
      setModalDescargas({ recurso, descargas: [] });
    }
  };

  /* ── Guardar recurso (nuevo o editar) ── */
  const guardarRecurso = async () => {
    if (!form.titulo.trim()) { showToast('El título es obligatorio','error'); return; }
    setGuardando(true);
    try {
      const esNuevo = !form.id;
      const slug = form.slug || slugify(form.titulo);
      const action = esNuevo ? 'recurso_crear' : 'recurso_editar';
      const r = await fetch(`${API_LEADS}?action=${action}`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ ...form, slug }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(esNuevo ? 'Recurso creado' : 'Recurso actualizado');
      setModalEdit(null);
      setModalNuevo(false);
      fetchRecursos();
    } catch(e) { showToast(e.message,'error'); }
    finally { setGuardando(false); }
  };

  /* ── Subir archivo ── */
  const subirArchivo = async (file, slug) => {
    if (!file) return;
    if (file.size > 50 * 1024 * 1024) { showToast('El archivo supera 50 MB','error'); return; }
    setUploading(true); setProgreso(0);
    const fd = new FormData();
    fd.append('archivo', file);
    if (slug) { fd.append('recurso_slug', slug); fd.append('sobrescribir','si'); }
    try {
      const iv = setInterval(()=>setProgreso(p=>Math.min(p+12,85)),200);
      const r  = await fetch(API_UPLOAD, { method:'POST', body:fd });
      clearInterval(iv); setProgreso(100);
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(`✓ Archivo subido: ${j.data.nombre} (${j.data['tamaño_kb']} KB)`);
      setModalUpload(null);
      fetchRecursos();
    } catch(e) { showToast(e.message||'Error al subir','error'); }
    finally { setUploading(false); setTimeout(()=>setProgreso(0),1000); }
  };

  /* ── Copiar link ── */
  const copiarLink = (slug, fuente) => {
    const url = `${BASE_URL}/${slug}?utm_source=${fuente}&utm_medium=social`;
    navigator.clipboard.writeText(url);
    setCopiedLink(`${slug}-${fuente}`);
    setTimeout(()=>setCopiedLink(null),2000);
    showToast('Link copiado');
  };

  /* ── Abrir editar ── */
  const abrirEditar = r => {
    setForm({ id:r.id, titulo:r.titulo, descripcion:r.descripcion||'', tipo:r.tipo, categoria:r.categoria||'Lenguaje', slug:r.slug, utm_campaign:r.utm_campaign||'' });
    setModalEdit(r);
  };

/* ── Toggle activo ── */
const toggleActivo = async (recurso) => {
  const nuevoValor = recurso.activo ? 0 : 1;
  setRecursos(rs => rs.map(r => r.id === recurso.id ? {...r, activo: nuevoValor} : r));
  try {
    const res = await fetch(`${API_LEADS}?action=recurso_toggle`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: recurso.id, activo: nuevoValor }),
    });
    const j = await res.json();
    if (!j.success) throw new Error(j.message);
    showToast(nuevoValor ? 'Recurso visible' : 'Recurso ocultado');
  } catch(e) {
    setRecursos(rs => rs.map(r => r.id === recurso.id ? {...r, activo: recurso.activo} : r));
    showToast(e.message, 'error');
  }
};

/* ── Abrir nuevo ── */
const abrirNuevo = () => {
    setForm(FORM_EMPTY);
    setModalNuevo(true);
  };

  return (
    <div className="arg-page">

      {toast && (
        <div className={`arg-toast arg-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="arg-header">
        <div>
          <h1>Recursos Gratuitos</h1>
          <p>Sube materiales, edita la info y genera links para redes sociales</p>
        </div>
        <div className="arg-header__actions">
          <button className="arg-btn-ghost" onClick={fetchRecursos}><IconRefresh/> Actualizar</button>
          <button className="arg-btn-primary" onClick={abrirNuevo}><IconPlus/> Nuevo recurso</button>
        </div>
      </div>

      {/* ── GRID ── */}
      <div className="arg-grid">
        {loading
          ? [...Array(6)].map((_,i)=><div key={i} className="arg-card arg-card--skeleton"><div className="arg-skel"/></div>)
          : recursos.map(r => {
            const tieneArchivo = !!r.archivo_url;
            return (
              <div className={`arg-card ${tieneArchivo?'arg-card--completo':'arg-card--pendiente'}`} key={r.id}>

                {/* Estado + acciones */}
                <div className="arg-card__toprow">
                  {tieneArchivo
                    ? <span className="arg-estado-ok"><IconCheck/> Archivo listo</span>
                    : <span className="arg-estado-pending">⚠ Sin archivo</span>
                  }
                  
                  <div className="arg-card__acciones">
                  <button className="arg-icon-btn arg-icon-btn--edit" onClick={()=>abrirEditar(r)} title="Editar info"><IconEdit/></button>
                  <button className="arg-icon-btn arg-icon-btn--users" onClick={()=>verDescargas(r)} title="Ver descargas">
                    <IconUsers/>
                    {r.total_descargas > 0 && <span className="arg-count-dot">{r.total_descargas}</span>}
                  </button>
                  <button
                    className={`arg-icon-btn ${r.activo ? 'arg-icon-btn--activo' : 'arg-icon-btn--inactivo'}`}
                    onClick={() => toggleActivo(r)}
                    title={r.activo ? 'Ocultar recurso' : 'Mostrar recurso'}
                  >
                    {r.activo ? <IconEye/> : <IconEyeOff/>}
                  </button>
                </div>


                </div>

                {/* Badges */}
                <div className="arg-card__meta">
                  <span className={`arg-badge arg-badge--${TIPO_COLOR[r.tipo]||'verde'}`}>{r.tipo}</span>
                  {r.categoria && <span className="arg-badge arg-badge--gris">{r.categoria}</span>}
                </div>

                <h3>{r.titulo}</h3>
                {r.descripcion && <p className="arg-card__desc">{r.descripcion}</p>}

                <div className="arg-card__stats">
                  <span><IconDownload/> {r.total_descargas} descarga{r.total_descargas!==1?'s':''}</span>
                </div>

                {/* Archivo */}
                {tieneArchivo && (
                  <div className="arg-archivo-actual">
                    <span>{EXT_ICON[r.archivo_url.split('.').pop().toLowerCase()]||'📎'}</span>
                    <a href={r.archivo_url} target="_blank" rel="noopener noreferrer" className="arg-archivo-actual__link">
                      Ver archivo ↗
                    </a>
                  </div>
                )}

                <button
                  className={`arg-btn-upload ${tieneArchivo?'arg-btn-upload--reemplazar':'arg-btn-upload--nuevo'}`}
                  onClick={()=>setModalUpload(r.slug)}
                >
                  <IconUpload/> {tieneArchivo?'Reemplazar archivo':'Subir archivo'}
                </button>

                {/* Links */}
                <div className="arg-links">
                  <p className="arg-links__label">Links para compartir:</p>
                  {[
                    {fuente:'instagram',Icon:IconInstagram,label:'Instagram'},
                    {fuente:'whatsapp', Icon:IconWhatsapp, label:'WhatsApp'},
                    {fuente:'qr',       Icon:IconQR,       label:'QR'},
                  ].map(({fuente,Icon,label})=>{
                    const copied = copiedLink===`${r.slug}-${fuente}`;
                    return (
                      <div className="arg-link-row" key={fuente}>
                        <span className="arg-link-row__label"><Icon/> {label}</span>
                        <button className={`arg-link-copy ${copied?'arg-link-copy--copiado':''}`} onClick={()=>copiarLink(r.slug,fuente)}>
                          {copied?<><IconCheck/> Copiado</>:<><IconLink/> Copiar</>}
                        </button>
                      </div>
                    );
                  })}
                </div>

              </div>
            );
          })
        }
      </div>

      {/* ══ MODAL SUBIDA ══ */}
      {modalUpload && (
        <div className="arg-overlay" onClick={()=>!uploading&&setModalUpload(null)}>
          <div className="arg-modal" onClick={e=>e.stopPropagation()}>
            <div className="arg-modal__head">
              <div><h2>Subir archivo</h2><p>Recurso: <strong>{modalUpload}</strong></p></div>
              {!uploading && <button className="arg-modal__close" onClick={()=>setModalUpload(null)}><IconClose/></button>}
            </div>
            <div className="arg-modal__body">
              <div className="arg-formatos">
                <p>Formatos aceptados:</p>
                <div className="arg-formatos__tags">
                  {['PDF','Word','PowerPoint','Excel','ZIP','MP4','Imágenes'].map(f=>(
                    <span key={f} className="arg-formato-tag">{f}</span>
                  ))}
                </div>
                <p className="arg-formatos__limite">Tamaño máximo: 50 MB</p>
              </div>
              <div
                className={`arg-drop ${dragOver?'arg-drop--active':''} ${uploading?'arg-drop--uploading':''}`}
                onDragOver={e=>{e.preventDefault();setDragOver(true)}}
                onDragLeave={()=>setDragOver(false)}
                onDrop={e=>{e.preventDefault();setDragOver(false);const f=e.dataTransfer.files[0];if(f)subirArchivo(f,modalUpload)}}
                onClick={()=>!uploading&&fileRef.current?.click()}
              >
                <input ref={fileRef} type="file"
                  accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip,.mp4,.png,.jpg,.jpeg"
                  style={{display:'none'}}
                  onChange={e=>{const f=e.target.files[0];if(f)subirArchivo(f,modalUpload)}}
                />
                {uploading ? (
                  <div className="arg-drop__uploading">
                    <div className="arg-progreso"><div className="arg-progreso__fill" style={{width:`${progreso}%`}}/></div>
                    <p>Subiendo… {progreso}%</p>
                  </div>
                ) : (
                  <>
                    <div className="arg-drop__icon"><IconFile/></div>
                    <p className="arg-drop__text">
                      <strong>Arrastra tu archivo aquí</strong>
                      <span>o haz clic para seleccionarlo</span>
                    </p>
                  </>
                )}
              </div>
            </div>
            {!uploading && (
              <div className="arg-modal__foot">
                <button className="arg-btn-ghost" onClick={()=>setModalUpload(null)}>Cancelar</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ══ MODAL EDITAR / NUEVO ══ */}
      {(modalEdit || modalNuevo) && (
        <div className="arg-overlay" onClick={()=>{setModalEdit(null);setModalNuevo(false)}}>
          <div className="arg-modal arg-modal--form" onClick={e=>e.stopPropagation()}>
            <div className="arg-modal__head">
              <div>
                <h2>{modalNuevo?'Nuevo recurso':'Editar recurso'}</h2>
                <p>{modalNuevo?'Completa la información del recurso':modalEdit?.titulo}</p>
              </div>
              <button className="arg-modal__close" onClick={()=>{setModalEdit(null);setModalNuevo(false)}}><IconClose/></button>
            </div>
            <div className="arg-modal__body">
              <div className="arg-form-grid">

                <div className="arg-field arg-field--full">
                  <label>Título <span className="arg-req">*</span></label>
                  <input type="text" className="arg-input" placeholder="Ej: Guía de evaluación del lenguaje infantil"
                    value={form.titulo}
                    onChange={e=>{setF('titulo',e.target.value);if(modalNuevo)setF('slug',slugify(e.target.value))}}
                  />
                </div>

                <div className="arg-field">
                  <label>Tipo</label>
                  <select className="arg-input arg-sel" value={form.tipo} onChange={e=>setF('tipo',e.target.value)}>
                    {TIPOS.map(t=><option key={t}>{t}</option>)}
                  </select>
                </div>

                <div className="arg-field">
                  <label>Categoría</label>
                  <select className="arg-input arg-sel" value={form.categoria} onChange={e=>setF('categoria',e.target.value)}>
                    {CATEGORIAS.map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>

                <div className="arg-field arg-field--full">
                  <label>Descripción</label>
                  <textarea className="arg-input arg-textarea" rows={3}
                    placeholder="Breve descripción de lo que incluye el recurso…"
                    value={form.descripcion} onChange={e=>setF('descripcion',e.target.value)}
                  />
                </div>

                <div className="arg-field">
                  <label>Slug (URL) <span className="arg-hint">auto-generado</span></label>
                  <input type="text" className="arg-input" placeholder="guia-evaluacion-lenguaje"
                    value={form.slug} onChange={e=>setF('slug',slugify(e.target.value))}
                  />
                  {form.slug && (
                    <span className="arg-field__preview">
                      /gratis/<strong>{form.slug}</strong>
                    </span>
                  )}
                </div>

                <div className="arg-field">
                  <label>UTM Campaign <span className="arg-hint">para analytics</span></label>
                  <input type="text" className="arg-input" placeholder="guia-lenguaje-2025"
                    value={form.utm_campaign} onChange={e=>setF('utm_campaign',e.target.value)}
                  />
                </div>

              </div>
            </div>
            <div className="arg-modal__foot">
              <button className="arg-btn-ghost" onClick={()=>{setModalEdit(null);setModalNuevo(false)}} disabled={guardando}>Cancelar</button>
              <button className="arg-btn-primary" onClick={guardarRecurso} disabled={guardando}>
                {guardando?<span className="arg-spinner"/>:modalNuevo?<><IconPlus/> Crear recurso</>:<><IconCheck/> Guardar cambios</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL DESCARGAS ══ */}
      {modalDescargas && (
        <div className="arg-overlay" onClick={()=>setModalDescargas(null)}>
          <div className="arg-modal arg-modal--descargas" onClick={e=>e.stopPropagation()}>
            <div className="arg-modal__head">
              <div>
                <h2>Quién descargó</h2>
                <p>{modalDescargas.recurso.titulo}</p>
              </div>
              <button className="arg-modal__close" onClick={()=>setModalDescargas(null)}><IconClose/></button>
            </div>
            <div className="arg-modal__body arg-modal__body--descargas">
              {modalDescargas.descargas.length === 0 ? (
                <div className="arg-empty">
                  <p>Aún nadie ha descargado este recurso.</p>
                  <span>Comparte el link en redes para empezar a captar leads.</span>
                </div>
              ) : (
                <>
                  <div className="arg-desc-stats">
                    <strong>{modalDescargas.descargas.length}</strong>
                    <span>personas descargaron este recurso</span>
                  </div>
                  <div className="arg-desc-lista">
                    {modalDescargas.descargas.map((d,i) => (
                      <div className="arg-desc-item" key={i}>
                        <div className="arg-desc-avatar">{(d.nombre||'?')[0].toUpperCase()}</div>
                        <div className="arg-desc-info">
                          <strong>{d.nombre}</strong>
                          <span>{d.email}</span>
                          {d.telefono && <span>{d.telefono}</span>}
                        </div>
                        <div className="arg-desc-meta">
                          <span className={`arg-badge arg-badge--${d.perfil==='profesional'?'verde':d.perfil==='familia'?'azul':'gris'}`}>{d.perfil}</span>
                          <span className="arg-desc-fuente">
                            {d.fuente==='instagram'?'📸':d.fuente==='whatsapp'?'💬':d.fuente==='qr'?'📱':'🌐'}
                            {d.fuente}
                          </span>
                          <span className="arg-desc-fecha">{d.fecha}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="arg-modal__foot">
              <button className="arg-btn-ghost" onClick={()=>setModalDescargas(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}